import React, { useEffect, useRef, useState } from "react";
import { useGlobalState } from "./GlobalStateProvider";
import "./LogModal.css"
import { JudgeRes, PASS } from "./NazoPhase";
import { playSE } from "./SoundEffect";

const LogModal: React.FC = () => {
  const { isBusy, setBusy, ansArray, setAnsArray, currentStep, setCurrentStep, logElements, hasKey, setHasKey } = useGlobalState();
  const [VisibleLogNazo1, setVisibleLogNazo1] = useState<number>(0);
  const [VisibleLogNazo2, setVisibleLogNazo2] = useState<number>(0);
  const [VisibleLogNazo5, setVisibleLogNazo5] = useState<number>(0);
  const [phase5AnsEffect, setPhase5AnsEffect] = useState<string>("");
  const [phase5SentenceEffect, setPhase5SentenceEffect] = useState<string>("");
  const phase5AnsInputRef = useRef<HTMLInputElement | null>(null);

  const sendRepeatAns = async () => {
    if (!phase5AnsInputRef.current || !phase5AnsInputRef.current.value) return;
    const currentPhase = Math.floor(currentStep / 10);
    if (ansArray[currentPhase][VisibleLogNazo5]) return;
    setBusy(true);
    const res: JudgeRes = await judge();
    if (res.judge === "ok" && currentPhase === 6) {
      setPhase5AnsEffect("flash-y");
      playSE("se1");
      let newArr = [...ansArray];
      const ex = phase5AnsInputRef.current?.value ?? "回答済";
      newArr[currentPhase][VisibleLogNazo5] = res.exemplar ?? ex;
      setAnsArray(newArr);
      setTimeout(() => {
        setPhase5AnsEffect("");
        setVisibleLogNazo5(0);
        setBusy(false);
        if (ansArray[6][1] && ansArray[6][2] && ansArray[6][3]) {
          setPhase5SentenceEffect("flash-y");
        }
      }, 2000);
    } else if (res.judge === "ok" && currentPhase === 7) {
      setPhase5AnsEffect("flash-b");
      playSE("se1");
      let newArr = [...ansArray];
      const ex = phase5AnsInputRef.current?.value ?? "回答済";
      newArr[currentPhase][VisibleLogNazo5] = res.exemplar ?? ex;
      setAnsArray(newArr);
      setTimeout(() => {
        setPhase5AnsEffect("");
        setVisibleLogNazo5(0);
        setBusy(false);
        if (ansArray[7][1] && ansArray[7][2] && ansArray[7][3]) {
          setPhase5SentenceEffect("flash-b");
          setTimeout(() => {
            setCurrentStep(71);
          }, 2000);
        }
      }, 2000);
    } else {
      setPhase5AnsEffect("shake");
      playSE("se2");
      setTimeout(() => {
        setPhase5AnsEffect("");
        setBusy(false);
      }, 1000);
    }
  };

  const judge: () => Promise<JudgeRes> = async () => {
    const ur_ans = phase5AnsInputRef.current?.value;
    if (ur_ans) {
      let dat = { "q": `ques${Math.floor(currentStep / 10)}${VisibleLogNazo5}`, "a": ur_ans };
      let response = await fetch(PASS, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(dat)
      });
      let res = await response.json();
      return res;
    }
    return { "judge": "ng" };
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      sendRepeatAns();
    }
  };

  const phase5SentenceSpan = (key: number) => {
    const currentPhase = Math.floor(currentStep / 10);
    if (currentPhase < 5) return "";
    switch (key) {
      case 1:
      case 2:
      case 3:
        return ansArray[currentPhase][key] ?? "";
      case 1.5:
        return ansArray[currentPhase][1] !== null
          && ansArray[currentPhase][2] !== null
          ? (currentPhase == 6 ? "に" : "の")
          : "";
      case 2.5:
        return ansArray[currentPhase][2] !== null
          && ansArray[currentPhase][3] !== null
          ? ("を")
          : "";
      default:
        return "";
    }
  };

  const getKey = (e: React.MouseEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    const rect = img.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const clickY = e.clientY - rect.top;
    const ratioX = clickX / rect.width;
    const ratioY = clickY / rect.height;
    const keyBox = {
      xMin: 0.377,
      xMax: 0.452,
      yMin: 0.686,
      yMax: 0.760
    };
    if (ansArray[6][1] && ansArray[6][2] && ansArray[6][3] &&
      VisibleLogNazo1 == 4 &&
      ratioX >= keyBox.xMin && ratioX <= keyBox.xMax &&
      ratioY >= keyBox.yMin && ratioY <= keyBox.yMax) {
      setHasKey(true);
      setVisibleLogNazo1(9);
      playSE("se5");
    }
  };


  const phaseMap: { [key: string]: React.ReactElement } = {
    phase1: (<>
      <div id="log-phase1" className="nazo-log">
        <div id="log-1-wrapper">
          <label className="answered" onClick={() => setVisibleLogNazo1(1)}>
            <p className="fc">i</p>
            <p className="ans">{ansArray[1][1] ?? ""}</p>
          </label>
          <label className="answered" onClick={() => setVisibleLogNazo1(2)}>
            <p className="fc">layt</p>
            <p className="ans">{ansArray[1][2] ?? ""}</p>
          </label>
          <label className="answered" onClick={() => setVisibleLogNazo1(3)}>
            <p className="fc">samany</p>
            <p className="ans">{ansArray[1][3] ?? ""}</p>
          </label>
          <label className="answered" onClick={() => setVisibleLogNazo1(hasKey ? 9 : 4)}>
            <p className="fc">maxyk</p>
            <p className="ans">{ansArray[1][4] ?? ""}</p>
          </label>
          <label className="answered" onClick={() => setVisibleLogNazo1(5)}>
            <p className="fc">ton</p>
            <p className="ans">{ansArray[1][5] ?? ""}</p>
          </label>
          <label className="answered" onClick={() => setVisibleLogNazo1(6)}>
            <p className="fc">neym</p>
            <p className="ans">{ansArray[1][6] ?? ""}</p>
          </label>
          <label className="answered" onClick={() => setVisibleLogNazo1(7)}>
            <p className="fc">synayo</p>
            <p className="ans">{ansArray[1][7] ?? ""}</p>
          </label>
          <label className="answered" onClick={() => setVisibleLogNazo1(8)}>
            <p className="fc">tuen</p>
            <p className="ans">{ansArray[1][8] ?? ""}</p>
          </label>
        </div>
        {VisibleLogNazo1 > 0 &&
          <>
            <div className="log-img-wrapper">
              <img src={`${process.env.PUBLIC_URL}/img/nazo1${VisibleLogNazo1}.webp`} onClick={getKey} style={{ opacity: "0.7" }}></img>
              <input type="text" value={ansArray[1][VisibleLogNazo1] ?? ""} disabled={true}></input>
            </div>
            <div className="div-button" onClick={() => setVisibleLogNazo1(0)}>戻る</div>
          </>
        }
      </div>
    </>
    ),
    phase2: (
      <div id="log-phase2" className="nazo-log">
        <div id="log-2-wrapper">
          <div id="log-2-sq">
            <label id="log-2-1" onClick={() => setVisibleLogNazo2(1)}>
              <p className="no">1</p>
            </label>
            <label id="log-2-2" onClick={() => setVisibleLogNazo2(2)}>
              <p className="no">2</p>
            </label>
            <label id="log-2-3" onClick={() => setVisibleLogNazo2(3)}>
              <p className="no">3</p>
            </label>
            <label id="log-2-4" onClick={() => setVisibleLogNazo2(4)}>
              <p className="no">4</p>
            </label>
            <label id="log-2-5" onClick={() => setVisibleLogNazo2(5)}>
              <p className="no">5</p>
            </label>
          </div>
        </div>
        {VisibleLogNazo2 > 0 &&
          <>
            <div className="log-img-wrapper">
              <img src={`${process.env.PUBLIC_URL}/img/nazo2${VisibleLogNazo2}.webp`} style={{ opacity: "0.7" }}></img>
              <input type="text" value={ansArray[2][VisibleLogNazo2] ?? ""} disabled={true}></input>
            </div>
            <div className="div-button" onClick={() => setVisibleLogNazo2(0)}>戻る</div>
          </>
        }
      </div>
    ),
    phase31: (
      <div id="log-phase31" className="nazo-log">
        <div className="log-img-wrapper">
          <img src={`${process.env.PUBLIC_URL}/img/nazo31.webp`} style={{ opacity: "0.7" }}></img>
          <input type="text" value={ansArray[3][1] ?? ""} disabled={true}></input>
        </div>
      </div>
    ),
    phase32: (
      <div id="log-phase32" className="nazo-log">
        <div className="log-img-wrapper">
          <img src={`${process.env.PUBLIC_URL}/img/nazo32.webp`} style={{ opacity: "0.7" }}></img>
          <input type="text" value={ansArray[3][2] ?? ""} disabled={true}></input>
        </div>
      </div>
    ),
    phase33: (
      <div id="log-phase33" className="nazo-log">
        <div className="log-img-wrapper">
          <img src={`${process.env.PUBLIC_URL}/img/nazo33.webp`} style={{ opacity: "0.7" }}></img>
          <input type="text" value={ansArray[3][3] ?? ""} disabled={true}></input>
        </div>
      </div>
    ),
    phase34: (
      <div id="log-phase34" className="nazo-log">
        <div className="log-img-wrapper">
          <img src={`${process.env.PUBLIC_URL}/img/nazo34.webp`} style={{ opacity: "0.7" }}></img>
          <input type="text" value={ansArray[3][4] ?? ""} disabled={true}></input>
        </div>
      </div>
    ),
    phase35: (
      <div id="log-phase35" className="nazo-log">
        <div className="log-img-wrapper">
          <img src={`${process.env.PUBLIC_URL}/img/nazo35.webp`} style={{ opacity: "0.7" }}></img>
          <input type="text" value={ansArray[3][5] ?? ""} disabled={true}></input>
        </div>
      </div>
    ),
    phase36: (
      <div id="log-phase36" className="nazo-log">
        <div className="log-img-wrapper">
          <img src={`${process.env.PUBLIC_URL}/img/nazo36.webp`} style={{ opacity: "0.7" }}></img>
          <input type="text" value={ansArray[3][6] ?? ""} disabled={true}></input>
        </div>
      </div>
    ),
    phase4: (
      <div id="log-phase4" className="nazo-log">
        <div className="log-img-wrapper">
          <img src={`${process.env.PUBLIC_URL}/img/nazo40.webp`} style={{ opacity: "0.7" }}></img>
          <img src={`${process.env.PUBLIC_URL}/img/nazo41.webp`} style={{ opacity: "0.7" }}></img>
          <input type="text" value={ansArray[4][0] ?? ""} disabled={true}></input>
        </div>
      </div>
    ),
    phase5: (
      <div id="log-phase5" className="nazo-log">
        <div id="log-5-wrapper">
          <img id="log-5-paper1" src={`${process.env.PUBLIC_URL}/img/paper_51.webp`} onClick={() => setVisibleLogNazo5(1)}></img>
          <img id="log-5-paper2" src={`${process.env.PUBLIC_URL}/img/paper_52.webp`} onClick={() => setVisibleLogNazo5(2)}></img>
          <img id="log-5-paper3" src={`${process.env.PUBLIC_URL}/img/paper_53.webp`} onClick={() => setVisibleLogNazo5(3)}></img>
        </div>
        <p className={`sentence ${phase5SentenceEffect}`}>
          <span>これは、</span>
          <span>{phase5SentenceSpan(1)}</span>
          <span>{phase5SentenceSpan(1.5)}</span>
          <span>{phase5SentenceSpan(2)}</span>
          <span>{phase5SentenceSpan(2.5)}</span>
          <span>{phase5SentenceSpan(3)}</span>
          <span>本。</span>
        </p>
        {VisibleLogNazo5 > 0 &&
          <div className="log-img-wrapper">
            <img src={`${process.env.PUBLIC_URL}/img/nazo5${VisibleLogNazo5}.webp`} style={{ opacity: "0.7" }}></img>
            <input type="text" id="log5-ans" ref={phase5AnsInputRef} onKeyDown={handleKeyDown} className={phase5AnsEffect} disabled={isBusy} autoComplete="off"></input>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
              <div id="judge-button" className="div-button" onClick={sendRepeatAns}>決定</div>
              <div id="back-button" className="div-button" onClick={() => setVisibleLogNazo5(0)}>戻る</div>
            </div>
          </div>
        }
      </div>
    ),
    phase6: (
      <div id="log-phase6" className="nazo-log">
        <div className="log-img-wrapper">
          <input type="text" id="your-ans" value={ansArray[6][0] ?? ""} disabled={true}></input>
        </div>
      </div>
    )
  };

  const innerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }

    function adjustPadding() {
      const scrollbarWidth = getScrollbarWidth();
      if (innerRef.current)
        innerRef.current.style.paddingRight = `${scrollbarWidth + 20}px`;
    }

    window.addEventListener('resize', adjustPadding);
    window.addEventListener('load', adjustPadding);
    adjustPadding();

    return () => {
      window.removeEventListener('resize', adjustPadding);
      window.removeEventListener('load', adjustPadding);
    };
  }, []);

  useEffect(() => {
    setPhase5SentenceEffect("");
  }, [currentStep]);

  return <section id="log-modal">
    <div id="log-modal-inner" ref={innerRef}>
      {logElements.map((item, idx) => {
        if (typeof item === 'string') {
          return <React.Fragment key={idx}>{phaseMap[item]}</React.Fragment>;
        } else {
          return <React.Fragment key={idx}>{item}</React.Fragment>;
        }
      })}
    </div>
  </section>;
};

export default LogModal;
